<template>
  <c-modal-form
    :id="$getConst('INTERVIEW_MODAL_ID')"
    :submit-btn="false"
    title="Хотите повысить уровень обслуживания?"
  >
    <div class="text-center">
      <a
        :href="formsInterviewLink"
        class="btn background-white border-danger text-danger"
      >
        Оценить
      </a>
    </div>
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import { mapState } from 'vuex'

/**
 * Модальное окно "Хотите повысить уровень обслуживания?".
 */
export default {
  name: 'Interview',
  components: {
    CModalForm
  },
  computed: {
    ...mapState({
      formsInterviewLink: state => state.seo.forms.interview.interview.link
    })
  }
}
</script>
